export const PRODUCT_LIST = [
  { id: 10, name: '气旋混流水帘柜', desc: 'http://43.138.215.69/cyclone_spray.png', img: 'http://43.138.215.69/cyclone_spray.jpg' },
  { id: 7, name: '活性炭箱', desc: 'http://43.138.215.69/carbon_detail.png', img: 'http://43.138.215.69/aCarbon_box.jpg' },
  { id: 15, name: 'W型干式过滤器', desc: '', img: 'http://43.138.215.69/w_dryfilter.jpg' },
  { id: 4, name: 'UV活性炭一体机', desc: '', img: 'http://43.138.215.69/uv_acarbon.jpg' },
  { id: 14, name: 'PP生物滴滤塔', desc: 'http://43.138.215.69/biodetail.jpg', img: 'http://43.138.215.69/pp_biofilter.jpg' },
  { id: 2, name: 'PP喷淋塔', desc: '', img: 'http://43.138.215.69/pp_sptower.jpg' },
  { id: 13, name: '卧式喷淋塔', desc: '', img: 'http://43.138.215.69/horiz_sptower.jpg' },
  { id: 8, name: '滤筒除尘器', desc: '', img: 'http://43.138.215.69/cartridge_dust.jpg' },
  { id: 3, name: '催化燃烧', desc: 'http://43.138.215.69/RCO_detail.png', img: 'http://43.138.215.69/RCO.jpg' },
  { id: 9, name: '气旋混动喷淋塔', desc: 'http://43.138.215.69/CHdetail.png', img: 'http://43.138.215.69/CH_sptower.jpg' },
  { id: 1, name: '生物滴滤塔', desc: 'http://43.138.215.69/biodetail.jpg', img: 'http://43.138.215.69/biofilter.jpg' },
  { id: 12, name: '双极气旋混动喷淋塔', desc: 'http://43.138.215.69/BCHdetail.png', img: 'http://43.138.215.69/BCH_sptower.jpg' },
  { id: 11, name: '湿式静电除尘器', desc: '', img: 'http://43.138.215.69/wet_type.jpg' },
  { id: 6, name: '布袋除尘器', desc: '', img: 'http://43.138.215.69/bag_dust.jpg' }
]

export const KNOW_LIST = [
  {
    id: 1,
    title: '工业酸气酸性废气处理设备的性能特点',
    detail: {
      p1: '1、净化效率高：酸雾净化塔采用二级逆向喷淋，填料比表面积大，由试验研究确定的气液比保证了性能稳定，对各种浓度的酸性废气净化效率均可达到85%-95%',
      p2: '2、设备阻力低：在保证足够气液接触面积基础上，工业酸气酸性废气处理设备选用空气动力特性最佳的填料品种及结构形式，使设备阻力在额定风量下不超过40毫米水柱，是国内各种填料吸收塔中阻力最低的一种。这对于配用耐腐蚀低压通风机极为有利。',
      p3: '3、占地面积小：工业酸气酸性废气处理设备将塔体、吸收液槽、循环泵、吸收液管道系统组合成一套完整的设备，结构紧凑，便于现场安装及操作管理，占地面积小，无论对新建工程还是技改项目都可适应。工业酸气酸性废气处理设备的适用范围：化工、轻工、印染、医药、钢铁、机械、电子、仪表、电镀等工业部门生产过程中排放的硫酸、硝酸、盐酸、氢氟酸等尾气及硫氧化物（SOx）、氮氧化物（NOx）、碳氧化化物（CO、CO2）等酸性气体。'
    },
    time: '2022-07-11 09:34:42',
    img: 'http://43.138.215.69/CH_sptower.jpg'
  },
  {
    id: 2,
    title: '制鞋厂的废气工艺环节',
    detail: {
      p1: '制鞋厂的废气工艺环节：废气处理设备,喷淋塔,催化燃烧装置,UV光解。在国内众多的鞋厂中，采用的原辅料是牛皮、人造皮、布类、鞋底、鞋内里、胶水、鞋带、鞋用五金以及包装材料等，其工序为裁断、缝合、涂胶、前绑、后绑、压底、烘干、定型、脱楦、包装等工艺，生产能力可以达到年产400万双运动鞋。其中主要产生制鞋厂废气的工艺环节为以下几个：',
      p2: '1、鞋面商标的印刷时，油墨挥发产生的有机废气；',
      p3: '2、鞋面材料高频压型工序产生的废气，皮革高频产生的废气属恶臭气体范畴；',
      p4: '3、鞋底材料EVA、MD发泡过程，TPR、PVC注塑加热状况下产生的有机废气；',
      p5: '4、鞋底喷漆过程中产生有机废气；',
      p6: '5、鞋底中底贴合、鞋面鞋底粘胶成型过程使用的粘胶剂，产生挥发性有机废气；',
      p7: '6、清洗工序，需要使用溶剂，有机溶剂中主要含有苯、甲苯、丙酮、丁酮等，具有挥发性，也会产生废气污染。废气处理设备,喷淋塔,催化燃烧装置,UV光解。',
      p8: '当前制鞋行业已被列入挥发性有机物(VOCs)削减重点行业，因此就需要对制鞋厂有机废气进行治理。废气处理设备,喷淋塔,催化燃烧装置,UV光解。'
    },
    time: '2022-07-13 09:24:52',
    img: 'http://43.138.215.69/pp_sptower.jpg'
  },
  {
    id: 3,
    title: 'UV光解注塑加工的废气处理方案',
    detail: {
      p1: 'UV光解注塑加工的废气处理方案：注塑是现代塑料加工生产中常用的一种工艺，产品通常使用橡胶注塑和塑料注塑，在使用过程中，该工艺如果得不到有效的废气处理将会对大气造成破坏性影响。',
      p2: '注塑机在注塑加热过程中产生有机废气，其主要成分为粉尘颗粒物、非甲烷总烃类等有害物质。该废气有刺激性气味、略含毒性，对人体健康有较大的危害。无组织排放的苯乙烯、甲苯、有机废气等会对环境造成严重污染，对人体健康也会造成很大损害，所以塑料厂生产线不得不慎重进行废气治理。',
      p3: '目前，在对注塑废气处理时采用的工艺主要有以下几种：',
      p4: '1、吸附法：吸收法是利用物质溶解度的不同分离气态污染物的方法。吸收法净化气态污染物，是利用适当的吸收剂从废气中选择性地去除气态污染物以消 除污染。此方法高效、设备简单、一次性投资费用低，广泛应用于气态污染控制中。缺点：需对吸收后的液体进行处理，设备易受腐蚀。',
      p5: '2、光催化氧化原理是：在紫外线照射下光催化剂TiO2被活化，使H2O生成羟基;OH，然后;OH将VOCs恶臭污染物质氧化成CO2和H2O。对苯、乙苯、二甲苯的降解效果较好。缺点是：由于受量子效率所限，难以处理浓度高、流量大的废气。光催化氧化技术是目前适用范围较广，技术也较成熟的一种VOCs处理方法。',
      p6: '3、等离子催化氧化：低温等离子体内部富含电子、离子、自由基和激发态分子，其中高能电子与气体分子（原子）发生非弹性碰撞，将能量转换成基态分子（原子）的内能，发生激发、离解和电离等一系列过程，使气体处于活化状态。目前，非平衡等离子体的产生方法有很多种，如辉光放电、电晕法、流光放电法、沿面放电法等，应用较为广 泛的是介质阻挡放电（又称无声放电）方法。废气处理设备,喷淋塔,催化燃烧装置,UV光解。与其它除臭方法，如高温焚化法、催化燃烧法及活性炭吸附法比较，具有高效性、低能耗的优点。',
      p7: '4、催化燃烧法：是在催化剂的作用下，使有机废气中的碳氢化合物在温度较低的条件下迅速氧化成水和二氧化碳，达到治理的目的。但用于风量大的低浓度废气，费用较高，运行成本大。',
      p8: '注塑废气中含有大量对人体有害的成分，比如丙烯腈、非甲烷总烃、氯乙烯等，如果得不到及时有效的处理，将对车间工作人员的身体健康造成巨大的威胁，同时对环境造成损害。废气处理设备、喷淋塔、催化燃烧装置、UV光解。'
    },
    time: '2022-07-13 08:34:42',
    img: 'http://43.138.215.69/pp_biofilter.jpg'
  },
  {
    id: 4,
    title: 'UV光解注塑加工的废气处理方案',
    detail: {
      p1: 'UV光解注塑加工的废气处理方案：注塑是现代塑料加工生产中常用的一种工艺，产品通常使用橡胶注塑和塑料注塑，在使用过程中，该工艺如果得不到有效的废气处理将会对大气造成破坏性影响。',
      p2: '注塑机在注塑加热过程中产生有机废气，其主要成分为粉尘颗粒物、非甲烷总烃类等有害物质。该废气有刺激性气味、略含毒性，对人体健康有较大的危害。无组织排放的苯乙烯、甲苯、有机废气等会对环境造成严重污染，对人体健康也会造成很大损害，所以塑料厂生产线不得不慎重进行废气治理。',
      p3: '目前，在对注塑废气处理时采用的工艺主要有以下几种：',
      p4: '1、吸附法：吸收法是利用物质溶解度的不同分离气态污染物的方法。吸收法净化气态污染物，是利用适当的吸收剂从废气中选择性地去除气态污染物以消 除污染。此方法高效、设备简单、一次性投资费用低，广泛应用于气态污染控制中。缺点：需对吸收后的液体进行处理，设备易受腐蚀。',
      p5: '2、光催化氧化原理是：在紫外线照射下光催化剂TiO2被活化，使H2O生成羟基;OH，然后;OH将VOCs恶臭污染物质氧化成CO2和H2O。对苯、乙苯、二甲苯的降解效果较好。缺点是：由于受量子效率所限，难以处理浓度高、流量大的废气。光催化氧化技术是目前适用范围较广，技术也较成熟的一种VOCs处理方法。',
      p6: '3、等离子催化氧化：低温等离子体内部富含电子、离子、自由基和激发态分子，其中高能电子与气体分子（原子）发生非弹性碰撞，将能量转换成基态分子（原子）的内能，发生激发、离解和电离等一系列过程，使气体处于活化状态。目前，非平衡等离子体的产生方法有很多种，如辉光放电、电晕法、流光放电法、沿面放电法等，应用较为广 泛的是介质阻挡放电（又称无声放电）方法。废气处理设备,喷淋塔,催化燃烧装置,UV光解。与其它除臭方法，如高温焚化法及活性炭吸附法比较，具有高效性、低能耗的优点。',
      p7: '4、催化燃烧法：是在催化剂的作用下，使有机废气中的碳氢化合物在温度较低的条件下迅速氧化成水和二氧化碳，达到治理的目的。但用于风量大的低浓度废气，费用较高，运行成本大。',
      p8: '注塑废气中含有大量对人体有害的成分，比如丙烯腈、非甲烷总烃、氯乙烯等，如果得不到及时有效的处理，将对车间工作人员的身体健康造成巨大的威胁，同时对环境造成损害。废气处理设备、喷淋塔、催化燃烧装置、UV光解。'
    },
    time: '2022-07-13 08:34:42',
    img: 'http://43.138.215.69/pp_biofilter.jpg'
  },
  {
    id: 5,
    title: 'UV光解注塑加工的废气处理方案',
    detail: {
      p1: 'UV光解注塑加工的废气处理方案：注塑是现代塑料加工生产中常用的一种工艺，产品通常使用橡胶注塑和塑料注塑，在使用过程中，该工艺如果得不到有效的废气处理将会对大气造成破坏性影响。',
      p2: '注塑机在注塑加热过程中产生有机废气，其主要成分为粉尘颗粒物、非甲烷总烃类等有害物质。该废气有刺激性气味、略含毒性，对人体健康有较大的危害。无组织排放的苯乙烯、甲苯、有机废气等会对环境造成严重污染，对人体健康也会造成很大损害，所以塑料厂生产线不得不慎重进行废气治理。',
      p3: '目前，在对注塑废气处理时采用的工艺主要有以下几种：',
      p4: '1、吸附法：吸收法是利用物质溶解度的不同分离气态污染物的方法。吸收法净化气态污染物，是利用适当的吸收剂从废气中选择性地去除气态污染物以消 除污染。此方法高效、设备简单、一次性投资费用低，广泛应用于气态污染控制中。缺点：需对吸收后的液体进行处理，设备易受腐蚀。',
      p5: '2、光催化氧化原理是：在紫外线照射下光催化剂TiO2被活化，使H2O生成羟基;OH，然后;OH将VOCs恶臭污染物质氧化成CO2和H2O。对苯、乙苯、二甲苯的降解效果较好。缺点是：由于受量子效率所限，难以处理浓度高、流量大的废气。光催化氧化技术是目前适用范围较广，技术也较成熟的一种VOCs处理方法。',
      p6: '3、等离子催化氧化：低温等离子体内部富含电子、离子、自由基和激发态分子，其中高能电子与气体分子（原子）发生非弹性碰撞，将能量转换成基态分子（原子）的内能，发生激发、离解和电离等一系列过程，使气体处于活化状态。目前，非平衡等离子体的产生方法有很多种，如辉光放电、电晕法、流光放电法、沿面放电法等，应用较为广 泛的是介质阻挡放电（又称无声放电）方法。废气处理设备,喷淋塔,催化燃烧装置,UV光解。与其它除臭方法，如高温焚化法及活性炭吸附法比较，具有高效性、低能耗的优点。',
      p7: '4、催化燃烧法：是在催化剂的作用下，使有机废气中的碳氢化合物在温度较低的条件下迅速氧化成水和二氧化碳，达到治理的目的。但用于风量大的低浓度废气，费用较高，运行成本大。',
      p8: '注塑废气中含有大量对人体有害的成分，比如丙烯腈、非甲烷总烃、氯乙烯等，如果得不到及时有效的处理，将对车间工作人员的身体健康造成巨大的威胁，同时对环境造成损害。废气处理设备、喷淋塔、催化燃烧装置、UV光解。'
    },
    time: '2022-07-13 08:34:42',
    img: 'http://43.138.215.69/pp_biofilter.jpg'
  },
  {
    id: 6,
    title: 'UV光解注塑加工的废气处理方案',
    detail: {
      p1: 'UV光解注塑加工的废气处理方案：注塑是现代塑料加工生产中常用的一种工艺，产品通常使用橡胶注塑和塑料注塑，在使用过程中，该工艺如果得不到有效的废气处理将会对大气造成破坏性影响。',
      p2: '注塑机在注塑加热过程中产生有机废气，其主要成分为粉尘颗粒物、非甲烷总烃类等有害物质。该废气有刺激性气味、略含毒性，对人体健康有较大的危害。无组织排放的苯乙烯、甲苯、有机废气等会对环境造成严重污染，对人体健康也会造成很大损害，所以塑料厂生产线不得不慎重进行废气治理。',
      p3: '目前，在对注塑废气处理时采用的工艺主要有以下几种：',
      p4: '1、吸附法：吸收法是利用物质溶解度的不同分离气态污染物的方法。吸收法净化气态污染物，是利用适当的吸收剂从废气中选择性地去除气态污染物以消 除污染。此方法高效、设备简单、一次性投资费用低，广泛应用于气态污染控制中。缺点：需对吸收后的液体进行处理，设备易受腐蚀。',
      p5: '2、光催化氧化原理是：在紫外线照射下光催化剂TiO2被活化，使H2O生成羟基;OH，然后;OH将VOCs恶臭污染物质氧化成CO2和H2O。对苯、乙苯、二甲苯的降解效果较好。缺点是：由于受量子效率所限，难以处理浓度高、流量大的废气。光催化氧化技术是目前适用范围较广，技术也较成熟的一种VOCs处理方法。',
      p6: '3、等离子催化氧化：低温等离子体内部富含电子、离子、自由基和激发态分子，其中高能电子与气体分子（原子）发生非弹性碰撞，将能量转换成基态分子（原子）的内能，发生激发、离解和电离等一系列过程，使气体处于活化状态。目前，非平衡等离子体的产生方法有很多种，如辉光放电、电晕法、流光放电法、沿面放电法等，应用较为广 泛的是介质阻挡放电（又称无声放电）方法。废气处理设备,喷淋塔,催化燃烧装置,UV光解。与其它除臭方法，如高温焚化法及活性炭吸附法比较，具有高效性、低能耗的优点。',
      p7: '4、催化燃烧法：是在催化剂的作用下，使有机废气中的碳氢化合物在温度较低的条件下迅速氧化成水和二氧化碳，达到治理的目的。但用于风量大的低浓度废气，费用较高，运行成本大。',
      p8: '注塑废气中含有大量对人体有害的成分，比如丙烯腈、非甲烷总烃、氯乙烯等，如果得不到及时有效的处理，将对车间工作人员的身体健康造成巨大的威胁，同时对环境造成损害。废气处理设备、喷淋塔、催化燃烧装置、UV光解。'
    },
    time: '2022-07-13 08:34:42',
    img: 'http://43.138.215.69/pp_biofilter.jpg'
  }
]

export const getStaticProductById = (id) => PRODUCT_LIST.find(item => Number(item.id) === Number(id)) || {}

export const getStaticKnowById = (id) => KNOW_LIST.find(item => Number(item.id) === Number(id)) || {}
